import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getTourSteps } from './tourSteps';

const TourContext = createContext();

export const TourProvider = ({ children }) => {
  // Initialize help mode from localStorage, default to false (OFF by default)
  const [isHelpModeActive, setIsHelpModeActive] = useState(() => {
    const saved = localStorage.getItem('helpModeActive');
    return saved !== null ? JSON.parse(saved) : false; // Off by default
  });
  const [currentPage, setCurrentPage] = useState(null);
  const [triggerRobotAnimation, setTriggerRobotAnimation] = useState(0);
  const [activeTooltipId, setActiveTooltipId] = useState(null);

  const toggleHelpMode = (pageName) => {
    const newHelpModeState = !isHelpModeActive;
    setIsHelpModeActive(newHelpModeState);
    setCurrentPage(newHelpModeState ? pageName : null);
    localStorage.setItem('helpModeActive', JSON.stringify(newHelpModeState));
  };

  const enableHelpMode = useCallback((pageName) => {
    setIsHelpModeActive(true);
    setCurrentPage(pageName);
    localStorage.setItem('helpModeActive', JSON.stringify(true));
  }, []);

  const disableHelpMode = () => {
    setIsHelpModeActive(false);
    setCurrentPage(null);
    localStorage.setItem('helpModeActive', JSON.stringify(false));
  };

  const animateRobot = () => {
    setTriggerRobotAnimation(prev => prev + 1);
  };

  return (
    <TourContext.Provider value={{
      isHelpModeActive,
      currentPage,
      toggleHelpMode,
      enableHelpMode,
      disableHelpMode,
      triggerRobotAnimation,
      animateRobot,
      activeTooltipId,
      setActiveTooltipId,
    }}>
      {children}
    </TourContext.Provider>
  );
};

export const useHelp = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useHelp must be used within a TourProvider');
  }
  return context;
};

// Keep backward compatibility
export const useTour = useHelp;
